class PlannerData {

    constructor() {
        this.university = null;
        this.coursesByIdentifier = {};
        this.courseGroupsByName = {};
        this.courseGroups = new CourseGroupList();
        this.courses = this.createCourseList();
    }

    createCourseList() {
        return new CourseList();
    }

    courseForIdentifier(identifier) {
        return this.coursesByIdentifier[identifier];
    }

    courseGroupForName(name) {
        return this.courseGroupsByName[name];
    }

    load(results) {
        this.university = this.createUniversity(results);
        const thisObj = this;
        const groupNames = {};
        _.each(results['courses'], function (result) {
            if (result.is_active) {
                let course = thisObj.resultToCourse(result);
                if (course != null) {
                    thisObj.courses.add(course);
                    thisObj.coursesByIdentifier[course.getIdentifier()] = course;

                    let courseGroupName = course.getGroupName();
                    if (courseGroupName != null && !(courseGroupName in groupNames)) {
                        groupNames[courseGroupName] = 1;
                        let courseGroup = new CourseGroup({name: courseGroupName});
                        thisObj.courseGroups.add(courseGroup);
                        thisObj.courseGroupsByName[courseGroupName] = courseGroup;
                    }
                }
            }
        });

    }

    resultToCourse(result) {
        return new Course(result);
    };

    createUniversity(results) {
        return new University(results);
    }
}
